// extracted by mini-css-extract-plugin
export default {"chart":"CustomerChart_chart__9ZjP6","province":"CustomerChart_province__VzE4e","add":"CustomerChart_add__LSV+5"};